var map = {
	"./ds-badge.entry.js": [
		966,
		27
	],
	"./ds-bar-horizontal.entry.js": [
		967,
		28
	],
	"./ds-bar-vertical.entry.js": [
		968,
		29
	],
	"./ds-button.entry.js": [
		969,
		0,
		30
	],
	"./ds-card.entry.js": [
		970,
		31
	],
	"./ds-confirm.entry.js": [
		971,
		67
	],
	"./ds-country-dialog.entry.js": [
		972,
		32
	],
	"./ds-country-multiple.entry.js": [
		973,
		33
	],
	"./ds-dialog.entry.js": [
		974,
		34
	],
	"./ds-donut.entry.js": [
		975,
		35
	],
	"./ds-empty-state.entry.js": [
		976,
		0,
		36
	],
	"./ds-error.entry.js": [
		977,
		68
	],
	"./ds-eth-avatar.entry.js": [
		978,
		37
	],
	"./ds-eth-wallet.entry.js": [
		979,
		38
	],
	"./ds-etherscan-link.entry.js": [
		980,
		39
	],
	"./ds-explorer-link.entry.js": [
		981,
		40
	],
	"./ds-fieldset.entry.js": [
		982,
		15
	],
	"./ds-form.entry.js": [
		983,
		41
	],
	"./ds-icon.entry.js": [
		984,
		0,
		69
	],
	"./ds-input-bignumber.entry.js": [
		985,
		16
	],
	"./ds-input-checkbox.entry.js": [
		986,
		17
	],
	"./ds-input-date-picker.entry.js": [
		987,
		42
	],
	"./ds-input-date-range.entry.js": [
		988,
		43
	],
	"./ds-input-date.entry.js": [
		989,
		44
	],
	"./ds-input-datetime.entry.js": [
		990,
		45
	],
	"./ds-input-file-multiple.entry.js": [
		991,
		13
	],
	"./ds-input-file.entry.js": [
		992,
		14
	],
	"./ds-input-image.entry.js": [
		993,
		18
	],
	"./ds-input-number.entry.js": [
		994,
		19
	],
	"./ds-input-radio.entry.js": [
		995,
		20
	],
	"./ds-input-string.entry.js": [
		996,
		21
	],
	"./ds-line-over-time.entry.js": [
		997,
		46
	],
	"./ds-loader.entry.js": [
		998,
		47
	],
	"./ds-logo.entry.js": [
		999,
		3,
		70
	],
	"./ds-number.entry.js": [
		1000,
		48
	],
	"./ds-pagination.entry.js": [
		1001,
		49
	],
	"./ds-pie.entry.js": [
		1002,
		50
	],
	"./ds-progress.entry.js": [
		1003,
		51
	],
	"./ds-qrcode.entry.js": [
		1004,
		52
	],
	"./ds-radio-toggle.entry.js": [
		1005,
		53
	],
	"./ds-select-country.entry.js": [
		1006,
		54
	],
	"./ds-select-multiple.entry.js": [
		1007,
		22
	],
	"./ds-select-option.entry.js": [
		1008,
		55
	],
	"./ds-select-simple.entry.js": [
		1009,
		56
	],
	"./ds-select.entry.js": [
		1010,
		23
	],
	"./ds-sparkline.entry.js": [
		1011,
		57
	],
	"./ds-spinner.entry.js": [
		1012,
		58
	],
	"./ds-split-tag.entry.js": [
		1013,
		0,
		71
	],
	"./ds-tab.entry.js": [
		1014,
		59
	],
	"./ds-table.entry.js": [
		1015,
		60
	],
	"./ds-tabs.entry.js": [
		1016,
		61
	],
	"./ds-tag.entry.js": [
		1017,
		0,
		72
	],
	"./ds-text-area.entry.js": [
		1018,
		24
	],
	"./ds-text-editor.entry.js": [
		1019,
		25
	],
	"./ds-toast.entry.js": [
		1020,
		62
	],
	"./ds-token-selector.entry.js": [
		1021,
		63
	],
	"./ds-token-subscription.entry.js": [
		1022,
		3,
		73
	],
	"./ds-tooltip.entry.js": [
		1023,
		64
	],
	"./ds-user-menu.entry.js": [
		1024,
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 581;
module.exports = webpackAsyncContext;